export default __webpack_public_path__ + "static/media/HoldingUpPuzzlePiece.b2e64fdc.svg";